import { Box } from '@mui/material';
import { DataGrid, gridClasses, type GridColDef, type GridRowsProp, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { type DataGridProps } from '@mui/x-data-grid/models/props/DataGridProps';
import { type FC } from 'react';

import { NoResultsOverlay, NoRowsOverlay } from '../TableOverlays.js';

interface TableProps extends DataGridProps{
  columns: GridColDef[];
  rows: GridRowsProp;
  pageSize?: number;
  isLoading?: boolean;
  NoRowsOverlayText: string;
  toolbar?: boolean;
}
const Table: FC<TableProps> = ({columns, rows,slots, pageSize = 5, pageSizeOptions = [5, 10, 25, 50, 100], isLoading, NoRowsOverlayText, toolbar,  ...props}) => {
  return (
    <DataGrid
      columns={columns}
      rows={rows}
      slots={{
        noRowsOverlay: () => <NoRowsOverlay text={NoRowsOverlayText} />,
        noResultsOverlay: NoResultsOverlay,
        toolbar: toolbar ? () => (
          <Box
            sx={{
              p: 0.5,
              pb: 0,
            }}
          >
            <GridToolbarQuickFilter
              debounceMs={200} // time before applying the new quick filter value
            />
          </Box>
        ) : null,
        ...slots,
      }}
      autoHeight
      disableColumnResize
      disableRowSelectionOnClick
      initialState={{
        pagination: {
          paginationModel: { page: 0, pageSize },
        },
      }}
      loading={isLoading}
      slotProps={{
        loadingOverlay: {
          variant: 'linear-progress',
          noRowsVariant: 'skeleton',
        },
      }}
      pageSizeOptions={pageSizeOptions}
      sx={{
        [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
          outline: 'none',
        },
        [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]: {
          outline: 'none',
        },
        '--DataGrid-overlayHeight': '200px',
      }}
      {...props}
    />
  );
};

export default Table;
